export default __webpack_public_path__ + "static/media/news2.57ca8e0f.png";